import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
  XMLHttpRequestHandler,
  XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { tagsEdit_template } from "../components/templates/tagsEdit_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";
import { UploadStatusHandler } from "../utils/UploadStatusHandler";
//import {imagePickerHelper} from '../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";
import { array } from "@amcharts/amcharts4/core";
import { Locale } from "../utils/types/locale";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let imageDescriptionEditor;
let imageCaptionEditor;
let prodRevReviewText;
let contentEditor;

export class tags_edit extends vnModule_knockoutJS {
  protected XHRHdl: XMLHttpRequestHandler;
  protected imageXHRHdl: XMLHttpRequestHandler;
  protected editForm: tagsEdit_template;
  protected validationsList: validationsList_template;
  public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
  protected progressBar: HTMLProgressElement;
  protected uploadProgress: any;
  protected _isLeavePageWarningNeeded: boolean = true;
  protected XHRHdlCaller: string;
  protected textAreaEditor;
  protected textAreaDefaultEditor;
  protected CKEDITOR_CONFIG = {
    toolbar: ["bold", "|", "italic", "link"],
  };
  //protected imagePickerHelper: imagePickerHelper;

  protected getModuleName() {
    return "tags_edit";
  }

  protected getImagePickerHelper() {
    return this.editForm.imagePickerHelper;
  }

  protected getVideoPickerHelper() {
    return this.editForm.videoPickerHelper;
  }

  buildContent(): Array<Element> {
    // create the users list
    this.editForm = new tagsEdit_template("editForm", this.viewModel, this);

    let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
    let loadedModule = zoneHeader.loadedModule;
    (<header>loadedModule).setHeaderTitle("Tag Form");

    return [this.editForm.build()];
  }

  fillPage(): void {
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      this.editForm.setIdBrand(idBrand);
      this.getVideoPickerHelper().getVideoReferences();
    }

    this.editForm.buildDatePickerCalendar();
    this.getFormData();
  }

  protected setupSpecRichTextEditors = (
    newValue: boolean,
    type: "override" | "default"
  ) => {
    if (
      type === "override" ||
      !this.editForm.getTemplateViewModel().idBrand()
    ) {
      this.setUpCkEditorTagsEditDefaultTextArea(newValue);
    }
    if (this.editForm.getTemplateViewModel().idBrand()) {
      this.setUpCkEditorTagsEditTextArea(newValue);
    }
  };

  public cancelForm() {
    this.cancel();
  }

  protected cancel() {
    this.releaseLock("cancel");
  }

  protected releaseLock(sourceAction: string) {
    // request a lock release
    let usrReq_url = this.buildReleaseTagLockUrl();
    let usrReq_params: Array<Array<string>> = [];
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onPostRequestReleaseLockReturn;
    this.XHRHdl.execute();
  }

  private buildReleaseTagLockUrl() {
    let idTag = this.getVnAppZone().getApp().params.idTag;

    let endpoint: string = "/api/tags/release/" + idTag;
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      endpoint = "/api/brand/" + idBrand + "/tags/release/" + idTag;
    }
    return endpoint;
  }

  protected onPostRequestReleaseLockReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let redirectionUrl = obj.getVnAppZone().app.getLastRoute();
        if (obj.XHRHdlCaller === "save") {
          redirectionUrl = obj.buildListRequestUrl();
        }

        page.redirect(redirectionUrl);
      });
    };
  }

  protected buildListRequestUrl(): string {
    let url = "/categorization/tags";

    if (this.isBrand()) {
      let brandId = this.getBrandId();
      url = "/brand/" + brandId + "/categorization/tags";
    }
    return url;
  }

  protected getFormData() {
    this.loadingIn(this.editForm.builtTemplate);

    let idTag = this.getVnAppZone().getApp().params.idTag;

    let usrReq_url: string = "/api/tags/get/" + idTag;
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      usrReq_url = "/api/brand/" + idBrand + "/tags/get/" + idTag;
    }

    let usrReq_params: Array<Array<string>> = [];

    let vm: any = { lockItem: true };

    usrReq_params.push(["data", ko.toJSON(vm)]);

    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
    this.XHRHdl.execute();
  }

  protected onGetRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        obj.editForm.setPermissions(responseParsed.permissions);
        if (responseParsed.tag) {
          obj.setTag(responseParsed);
          const {reviewScoreEmbargoEndDate} = responseParsed.tag.details
          obj.editForm.buildReviewScoreEmbargoEndDateCalendar(reviewScoreEmbargoEndDate || null);
        }
      });

      obj.loadingOut(obj.editForm.builtTemplate);
    };
  }

  public setTag(data): void {
    this.editForm.setId(data.tag.id);
    this.editForm.setName(data.tag.name);
    this.editForm.setIdReference(data.tag.idReference);
    this.editForm.setReferenceDescription(data.tag.referenceDescription);
    this.editForm.setSlug(data.tag.slug);
    this.editForm.setUrlHubPage(data.tag.urlHubPage);
    this.editForm.setIsAutoLinkerEnabled(data.tag.isAutoLinkerEnabled);
    this.editForm.setIsAutoLinkerThirdPartyServiceEnabled(data.tag.isAutoLinkerThirdPartyServiceEnabled);
    let values = [];
    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    const tag = data.tag;
    const specValues = data.specsValues;
    const specDefaults = data.specDefaults;
    const tagDefaults = tag.defaults;
    this.editForm.setIndexedValues(tag, specValues, specDefaults);

    if (tagDefaults) {
      this.editForm.setTagDefaults(tagDefaults);
      if (tagDefaults.image) {
        this.editForm.imageWidgetForDefaultBrandTagImage.setImage(
          tagDefaults.image
        );
      }

      if (tagDefaults.iconImage) {
        this.editForm.imageWidgetForDefaultTagIconImage.setImage(
          tagDefaults.iconImage
        );
      }

      if (tagDefaults.bannerImage) {
        this.editForm.imageWidgetForDefaultTagBannerImage.setImage(
          tagDefaults.bannerImage
        );
      }

      if (tagDefaults.imageGroup) {
        let imageGroupArray = JSON.parse(tagDefaults.imageGroup);
        if (
          typeof imageGroupArray[0] !== "undefined" &&
          imageGroupArray[0].images.length > 0
        ) {
          this.editForm.imageWidgetForDefaultBrandTagImageGroup.setSelectedImagesMarkup(
            imageGroupArray[0].source
          );
          this.editForm.imageWidgetForDefaultBrandTagImageGroup.setSelectedImages(
            imageGroupArray[0].images
          );
        }
      }
      if (tagDefaults.vignette) {
        this.editForm.defaultVignetteFilter.setOption(tagDefaults.vignette);
      }
    } else {
      this.editForm.setTagDefaults([]);
    }
    if (specDefaults) {
      this.editForm.setSpecDefaults(specDefaults);
    }
    if (data.specsValues) {
      values = data.specsValues;
      if (!this.isBrand()) {
        values = values.map((value) => {
          value.isDefault = true;
          return value;
        });
      }
      this.editForm.setSpecifications(values);
    }
    if (data.tag.type && data.tag.type.brandOwner) {
      this.editForm.setBrandOwner(data.tag.type.brandOwner);
    } else {
      this.editForm.setBrandOwner(null);
    }

    let validAutoPricingPartnerNames = [];
    if (data.validAutoPricingPartnerNames) {
      validAutoPricingPartnerNames = data.validAutoPricingPartnerNames;
      this.editForm.setValidAutoPricingPartnerNames(
        validAutoPricingPartnerNames
      );
    }
    if (data.tag.type) {
      this.editForm.setTagType(data.tag.type);
      this.editForm.setIdTagType(data.tag.type.id);
    } else {
      if (this.getVnAppZone().getApp().params.idBrand) {
        this.editForm.setTagType({ name: "Not Selected", id: 0 });
      }
    }

    // Set providers to incoming data
    if (data.tag.providerRelationships) {
      this.editForm.setProviders(data.tag.providerRelationships);
    }

    if (data.tag.details) {
      this.editForm.setSlug(data.tag.details.slug);
      this.editForm.setHasSlug(true);
      this.editForm.setTagColor(data.tag.details.color);
      if (data.tag.details.image) {
        this.editForm.imageWidgetForBrandTagImage.setImage(
          data.tag.details.image
        );
      }

      if (data.tag.details.iconImage) {
        this.editForm.imageWidgetForTagIconImage.setImage(
          data.tag.details.iconImage
        );
      }

      if (data.tag.details.bannerImage) {
        this.editForm.imageWidgetForTagBannerImage.setImage(
          data.tag.details.bannerImage
        );
      }

      if (data.tag.details.imageGroup) {
        let imageGroupArray = JSON.parse(data.tag.details.imageGroup);
        if (
          typeof imageGroupArray[0] !== "undefined" &&
          imageGroupArray[0].images.length > 0
        ) {
          this.editForm.imageWidgetForBrandTagImageGroup.setSelectedImagesMarkup(
            imageGroupArray[0].source
          );
          this.editForm.imageWidgetForBrandTagImageGroup.setSelectedImages(
            imageGroupArray[0].images
          );
        }
      }

      this.editForm.setIsTagSelectable(data.tag.details.isSelectable);
      this.editForm.setIsTagActive(data.tag.details.isActive);
      this.editForm.setDescription(data.tag.details.description);
      this.editForm.setSeoDescription(data.tag.details.shortDescription);
      this.editForm.setReviewScore(data.tag.details.reviewScore);
      this.editForm.setReviewText(data.tag.details.description);
      this.editForm.setTagVideo(data.tag.details.video || (data.tag.defaults && data.tag.defaults.video));
      this.editForm.setReviewScoreEmbargoEndDate(data.tag.details.reviewScoreEmbargoEndDate);
      this.editForm.setReviewScoreIsUnderEmbargo(data.tag.details.reviewScoreIsUnderEmbargo);



      let affiliateLinks = null;
      if (data.tag.details.affiliateLinks) {
        affiliateLinks = data.tag.details.affiliateLinks;
      }
      this.editForm.setAffiliateLinks(affiliateLinks);

      if (data.tag.details.vignette) {
        this.editForm.vignetteFilter.setOption(data.tag.details.vignette);
      }
    }

    if (this.editForm.getTemplateViewModel().isBrandOwner()) {
      this.editForm
        .getTemplateViewModel()
        .useOverride.subscribe((checked) =>
          this.setupSpecRichTextEditors(checked, "override")
        );
    } else {
      this.editForm
        .getTemplateViewModel()
        .useDefault.subscribe((checked) =>
          this.setupSpecRichTextEditors(!checked, "default")
        );
    }

    if (!this.editForm.getTemplateViewModel().idBrand()) {
      this.editForm.getTemplateViewModel().useDefault(false);
      this.editForm.getTemplateViewModel().useDefault(true);
    }

    this.editForm.setupCanEditThisTag();
    this.editForm.setupUseTagDefaults(data.tag);
    this.editForm.getTemplateViewModel().affiliateOptionLinks(this.editForm.getTemplateViewModel().getAffiliateOptionsList());
    this.editForm.getTemplateViewModel().affiliateOptionsString(this.editForm.getTemplateViewModel().buildAffiliateOptionsString());
    this.initializeCkEditors();

    const isTagActive = data.tag.details ? data.tag.details.isActive : false;
    if(idBrand && !isTagActive){
      this.editForm.toggleInactiveTagPopupVisibility();
    }
  }

  protected saveTag() {
    // LOADING : starts
    this.loadingIn(this.editForm.builtTemplate);

    this.XHRHdlCaller = "save";
    let formReq_url: string = "/api/tags/save/";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      formReq_url = "/api/brand/" + idBrand + "/tags/save";
    }
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = JSON.parse(
      ko.toJSON(this.editForm.getViewModelForRequest())
    );
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          obj.getVnAppZone().notification = new vn_app_zone_notification(
            vn_app_zone_notification.TYPE_SUCCESS,
            "Tag saved successfully !"
          );
          obj.releaseLock("save");
        });
        obj.loadingOut(obj.editForm.builtTemplate);
      };
    };
    XHRHdl.execute();
  }

  protected getTagByType(idType, keyword) {
    this.XHRHdl.cancelAndReset();

    let usrReq_url: string = "/api/tags/get_by_type/" + idType;
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      usrReq_url = "/api/brand/" + idBrand + "/tags/get_by_type/" + idType;
    }
    let subViewModel = { keyword: keyword, idTagType: idType };
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetTagRequestReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        let tags = responseParsed.data;
        if (tags) {
          obj.editForm.sendTagFilterUpdates(tags);
        }
      });
    };
  }

  protected getTagByTypes(tagTypesIds, keyword) {
    this.XHRHdl.cancelAndReset();

    let usrReq_url: string = "/api/tags/get_by_types/";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      usrReq_url = "/api/brand/" + idBrand + "/tags/get_by_types/";
    }
    let subViewModel = { keyword: keyword, tagTypesIds: tagTypesIds };
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.onReadyStateFunction = this.onGetTagByTypesRequestReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagByTypesRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        //check if user has article write permissions
        let responseParsed = JSON.parse(req.request.response);
        let tags = responseParsed.data;
        if (tags) {
          obj.editForm.sendTagFilterUpdates(tags);
        }
      });
    };
  }

  public setImageDescription(description) {
    // imageDescriptionEditor.setData(description, function () {
    //     this.resetUndo();
    // });
  }

  public setImageCaption(caption) {
    // imageCaptionEditor.setData(caption, function () {
    //     this.resetUndo();
    // });
  }

  public getImageDescription(description) {
    // return imageDescriptionEditor.getData();
  }

  public getImageCaption(description) {
    // return imageCaptionEditor.getData();
  }

  protected validateTagSpec(
    idField,
    idType,
    label,
    dataType,
    restrictionsArray,
    oldRestrictionsArray
  ) {
    // LOADING : starts
    this.loadingIn(this.editForm.builtTemplate);

    let formReq_url: string = "/api/tags/field/validate/";
    let formReq_params: Array<Array<string>> = [];

    let subViewModel = {
      idType: idType,
      label: label,
      idField: idField,
      dataType: dataType,
      typeRestrictions: restrictionsArray,
      oldTypeRestrictions: oldRestrictionsArray,
    };
    formReq_params.push(["data", ko.toJSON(subViewModel)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);
          if (responseParsed.data.valid) {
            obj.editForm.addSpecification();
          }
        });
        obj.loadingOut(obj.editForm.builtTemplate);
      };
    };
    XHRHdl.execute();
  }

  //image picker functions
  public getUrlBase(): string {
    let idBrand = this.getVnAppZone().app.params.idBrand;

    return idBrand ? "/api/brand/" + idBrand : "/api";
  }

  protected getImageData() {
    if (this.imageXHRHdl) {
      this.imageXHRHdl.cancelAndReset();
    }

    this.editForm.imagePicker.showLoading();

    let formReq_url: string = this.getUrlBase() + "/images/get/";
    let formReq_params: Array<Array<string>> = [];

    //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

    formReq_params.push([
      "data",
      ko.toJSON(this.editForm.imagePicker.getViewModelForRequest()),
    ]);

    this.imageXHRHdl = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    this.imageXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
    this.imageXHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
    this.imageXHRHdl.execute();
  }

  protected onGetImageDataReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);
        obj.updateImagePickerForm(responseParsed);
        obj.editForm.imagePicker.hideLoading();
        if (
          obj.editForm.imagePicker.getSelectedTab() == "images" ||
          obj.isSaveImage
        ) {
          obj.isSaveImage = false;
        }
        //TODO after save
      });
    };
  }

  protected updateImagePickerForm(responseParsed) {
    let selectedImages = this.editForm.imagePicker.getSelectedImages();

    if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
      for (let image of responseParsed.paginatedImages.data) {
        image.selected = false;
        let imageSelected = selectedImages.find((i) => i.id == image.id);
        if (imageSelected) {
          image.selected = true;
        }
        image.fileSize = this.bytesToSize(image.fileSize);
      }
      this.editForm.imagePicker.setImagesPagination(
        responseParsed.paginatedImages
      );
      this.editForm.imagePicker.setImageResults(
        responseParsed.paginatedImages.data
      );
    }

    if (responseParsed.ratios) {
      this.editForm.imagePicker.setRatios(responseParsed.ratios);
    }

    if (responseParsed.orientations) {
      this.editForm.imagePicker.setOrientations(responseParsed.orientations);
    }

    if (responseParsed.uploadSources) {
      this.editForm.imagePicker.setUploadSources(
        responseParsed.uploadSources,
        responseParsed.selectedUploadSource
      );
    }

    if (responseParsed.idBrand) {
      this.editForm.imagePicker.setIdBrand(responseParsed.idBrand);
    }
  }

  protected bytesToSize(bytes) {
    var sizes = ["KB", "MB", "GB", "TB"];
    if (bytes == 0) return "n/a";
    var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
    if (i == 0) return bytes + " " + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
  }

  protected insertImage(image, target) {
    if (target == "tag_image") {
      this.editForm.imageWidgetForBrandTagImage.setImage(image);
    } else if (target == "tag_image_icon") {
      this.editForm.imageWidgetForTagIconImage.setImage(image);
    } else if (target == "tag_banner_image") {
      this.editForm.imageWidgetForTagBannerImage.setImage(image);
    } else if (target == "default_tag_image") {
      this.editForm.imageWidgetForDefaultBrandTagImage.setImage(image);
    } else if (target == "default_tag_image_icon") {
      this.editForm.imageWidgetForDefaultTagIconImage.setImage(image);
    } else if (target == "default_tag_banner_image") {
      this.editForm.imageWidgetForDefaultTagBannerImage.setImage(image);
    } else if (target == "video_thumbnail") {
      this.getVideoPickerHelper().setThumbnailImage(image);
    }
  }

  protected buildImageTag(image, addCaption): string {
    let imgTag = "<img ";
    imgTag += 'src="' + image.url + '" ';
    if (image.altText != null) {
      imgTag += 'alt="' + image.altText + '" ';
    } else {
      imgTag += 'alt="" ';
    }
    imgTag += " width=" + image.width + " height=" + image.height + " />";

    //add caption
    if (addCaption && image.caption != null && image.caption.trim() != "") {
      imgTag = "[caption]" + imgTag + " " + image.caption + "[/caption]";
    }

    return imgTag;
  }

  public getTagTypesSuggestion(keyword, idElement) {
    this.XHRHdl.cancelAndReset();

    let subViewModel = {
      pagination: { itemPerPage: 25 },
      filter: { keyword: keyword },
      idElement: idElement,
    };
    let usrReq_url: string = "/api/search/tag/type/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagTypesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data.tagTypes) {
          if (response.data.idElement == 5) {
            response.data.tagTypes.forEach(function (tagType) {
              tagType.name += ` ${tagType.formattedDataset}`;
            });
            obj.editForm.restrictionFilter.setOptions(response.data.tagTypes);
          } else {
            obj.editForm.setTagTypeFilter(
              response.data.idElement,
              response.data.tagTypes
            );
          }
        }
      });
    };
  }

  public getLocaleSuggestion(keyword) {
    const locales = this.editForm.getLocales();

    if (typeof locales != "undefined") {
      let matches = locales.filter((l) => (
        l.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
        l.countryCode.toLowerCase() === keyword.toLowerCase()
      ));

      this.editForm.filterLocales.setOptions(matches);
      return matches;
    }

    return null;
  }

  public getVignettesSuggestion(keyword, onReadyStateFunction) {
    const idBrand = this.getVnAppZone().app.params.idBrand;

    this.XHRHdl.cancelAndReset();

    let subViewModel = {
      pagination: { itemPerPage: 25 },
      filter: { keyword: keyword },
    };
    let usrReq_url: string = idBrand
      ? `/api/brand/${idBrand}/search/tags/vignettes/`
      : `/api/search/tags/vignettes/`;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = onReadyStateFunction;
    this.XHRHdl.execute();
  }

  protected onGetVignettesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          const vignettes = response.data.map((vignette) => {
            vignette.name += ` (${vignette.id})`;
            return vignette;
          });

          obj.editForm.vignetteFilter.setOptions(vignettes);
        }
      });
    };
  }

  protected onGetDefaultVignettesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          const vignettes = response.data.map((vignette) => {
            vignette.name += ` (${vignette.id})`;
            return vignette;
          });

          obj.editForm.defaultVignetteFilter.setOptions(vignettes);
        }
      });
    };
  }

  public filterSimpleOnChange(idElement): void {
    if (idElement == "tagFilter") {
      this.editForm.addTag();
    } else if (idElement == "tagTypeFilter") {
      this.editForm.addTagType();
    } else if (idElement == "defaultTagFilter") {
      this.editForm.addTagDefault();
    } else if (
      idElement == "videoKeywordFilter" ||
      idElement == "filterVideoTag"
    ) {
      this.getVideoPickerHelper().getVideosData();
    } else if (idElement == "filterVideoTagEdit") {
      this.getVideoPickerHelper()
        .getVideoPickerEditTemplate()
        .updateSelectedTags();
    }

    // if (idElement == 'restrictionFilter') {
    //
    //     this.editForm.addRestriction();
    // }
    else {
      let idBrand = this.getVnAppZone().app.params.idBrand;
      if (idBrand) {
        this.getImageData();
      }
    }
  }

  public getTagsSuggestion(keyword, idElement) {
    this.XHRHdl.cancelAndReset();

    let subViewModel = {
      pagination: { itemPerPage: 25 },
      filter: { keyword: keyword },
      idElement: idElement,
    };
    let usrReq_url: string =
      "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    if (idElement == "filterVideoTag") {
      this.XHRHdl.onReadyStateFunction =
        this.onGetVideoPickerTagsSuggestionReturn;
    } else if (idElement == "filterVideoTagEdit") {
      this.XHRHdl.onReadyStateFunction =
        this.onGetVideoPickerEditTagsSuggestionReturn;
    } else {
      this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
    }
    this.XHRHdl.execute();
  }

  protected onGetTagsSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data.tags) {
          obj.editForm.sendTagFilterUpdates(response.data.tags);
        }
      });
    };
  }

  protected onGetVideoPickerTagsSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        if (response.data.tags) {
          obj.getVideoPickerHelper().setTagsSuggestions(response.data.tags);
        }
      });
    };
  }

  protected onGetVideoPickerEditTagsSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        if (response.data.tags) {
          obj.getVideoPickerHelper().setEditTagsSuggestions(response.data.tags);
        }
      });
    };
  }

  public getTagTypeById(idTagType, idElement) {
    this.XHRHdl.cancelAndReset();

    let subViewModel = { idElement: idElement };
    let usrReq_url: string = "/api/tags/type/get/" + idTagType;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetTagTypeByIdReturn;
    this.XHRHdl.execute();
  }

  protected onGetTagTypeByIdReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);

        if (response.data) {
          obj.editForm.restrictionFilter.setTagType(response.data);
        }
      });
    };
  }

  protected getTagTypes(listTagTypesId, handler) {
    if (listTagTypesId && listTagTypesId.length > 0) {
      if (this.XHRHdls[handler]) {
        this.XHRHdls[handler].cancelAndReset();
      }

      let usrReq_url: string = "/api/tag/types/get/";
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push([
        "data",
        ko.toJSON({
          filters: {
            ids: listTagTypesId,
          },
        }),
      ]);
      this.XHRHdls[handler] = new XMLHttpRequestHandler(
        usrReq_url,
        usrReq_params,
        this
      );

      if (handler == "getOldTagTypes") {
        this.XHRHdls[handler].onReadyStateFunction =
          this.onGetOldTagTypesReturn;
      } else {
        this.XHRHdls[handler].onReadyStateFunction = this.onGetTagTypesReturn;
      }
      this.XHRHdls[handler].execute();
    }
  }

  protected onGetTagTypesReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        if (response.data) {
          obj.editForm
            .getTemplateViewModel()
            .restrictionTypeArray(response.data);
        }
      });
    };
  }

  protected onGetOldTagTypesReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let response = JSON.parse(req.request.response);
        if (response.data) {
          obj.editForm
            .getTemplateViewModel()
            .oldRestrictionTypeArray(response.data);
        }
      });
    };
  }

  protected handleFiles(files) {
    this.uploadImages(files);
  }

  protected saveImages(
    images,
    insert,
    param,
    insertType = "image",
    widget = null
  ) {
    let formReq_url: string = this.getUrlBase() + "/images/save/";
    let formReq_params: Array<Array<string>> = [];

    let targetWidget = widget
      ? widget
      : this.editForm.imageWidgetForBrandTagImage;

    formReq_params.push(["data", ko.toJSON(images)]);

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let response = JSON.parse(req.request.response);

          targetWidget.setImage(response.images[0].image);
          obj.editForm.imagePicker.onImageSaveReturn(
            response.images,
            insert,
            param,
            insertType
          );
          obj.getImageData();
        });
      };
    };
    XHRHdl.execute();
  }

  protected filterSimpleCancel() {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }
  }

  protected uploadImages(files) {
    console.log("trial  - " + this.uploadStatus.currentTrial);

    let parent = this;
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = this.getUrlBase() + "/images/upload/";

    var formData = new FormData();

    this.initializeProgress(files.length);

    if (files.length > 1) {
      this.editForm.imagePicker.hideImageAdd();
      this.editForm.imagePicker.showLoading();
    }

    this.editForm.imagePicker.clearFilters();

    // upload status vars.
    this.uploadStatus.nextTrial();

    for (let i = 0; i < files.length; i++) {
      formData.append("file_" + i, files[i]);
    }
    if (idBrand) {
      formData.append("idBrand", idBrand);
    }

    let request = [];
    var xhttp = new XMLHttpRequest();
    request["request"] = xhttp;

    // Set POST method and ajax file path
    xhttp.open("POST", formReq_url, true);

    let onReadyStateFunction = function (req, obj) {
      return function () {
        if (req.request.readyState == 4) {
          if (req.request.status == 200) {
            // reset the upload status when successful operation is complete.
            obj.uploadStatus.reset();
            let fileElement: any = document.getElementById("fileElem");
            fileElement.value = "";
            let response = JSON.parse(req.request.response);

            obj.updateProgress(response.images.length, 100); // <- Add this

            if (response.images.length == 1 && response.errors.length == 0) {
              obj.editForm.imagePicker.editImage(response.images[0]);
              obj.editForm.imagePicker.hideLoading();
            }

            if (
              (response.images.length == 1 && response.errors.length == 1) ||
              response.images.length > 1
            ) {
              obj.editForm.imagePicker.hideImageAdd();
              obj.editForm.imagePicker.handleBulkImages(response.images);
              obj.editForm.imagePicker.hideLoading();

              if (response.errors.length == 1) {
                obj.editForm.imagePicker.imagesBulkEdit.validationsList.setMessages(
                  response.errors
                );
              }
            }
            obj.resetProgress();
            obj.validationTemplate.clearMessages();
          } else if (req.request.status == 400) {
            let responseParsed = JSON.parse(req.request.response);
            obj.editForm.imagePicker.imageAdd.validationsList.setMessages(
              responseParsed.validations
            );
            obj.editForm.imagePicker.hideLoading();
            window.scrollTo(0, 0);
          } else {
            obj.uploadStatus.isInProgress = false;
            obj.editForm.imagePicker.showUploadError();
          }
        }
      };
    };

    // call on request changes state
    xhttp.onreadystatechange = onReadyStateFunction(request, this);

    let firstTime = new Date().getTime();
    xhttp.upload.addEventListener("progress", function (e) {
      parent.uploadStatus.progress = e.loaded;
      let progressTime = new Date().getTime();
      let diff = progressTime - firstTime;
      firstTime = progressTime;
      console.log(
        "Upload Image progress: ",
        e.loaded,
        e.total,
        parent.uploadStatus.progress,
        diff
      );
    });

    xhttp.upload.addEventListener("loadend", (e) => {
      if (
        !parent.uploadStatus.isInProgress &&
        parent.uploadStatus.trialsReached()
      ) {
        xhttp.abort();
        parent.editForm.imagePicker.showPickerUploadError();
        parent.editForm.imagePicker.hideLoading();
      }
      console.log(
        "Upload Image Loadend: ",
        parent.uploadStatus.progress,
        e.loaded,
        e.total
      );
    });

    xhttp.upload.addEventListener("loadstart", (e) => {
      console.log("timeout started");
      setTimeout(() => {
        // check after one second if the progress is blocked then trigger another try.
        if (
          !parent.uploadStatus.isInProgress &&
          !parent.uploadStatus.trialsReached()
        ) {
          xhttp.abort();
          parent.uploadImages(files);
        }
      }, 1000);
    });

    // Send request with data
    xhttp.send(formData);
  }

  public reset() {
    this.uploadStatus.reset();
    this.editForm.imagePicker.hidePickerUploadError();
  }

  protected initializeProgress(numFiles) {
    this.progressBar = <HTMLProgressElement>(
      document.getElementById("progress-bar")
    );
    this.progressBar.value = 0;
    this.uploadProgress = [];

    for (let i = numFiles; i > 0; i--) {
      this.uploadProgress.push(0);
    }
  }

  protected resetProgress() {
    this.progressBar = <HTMLProgressElement>(
      document.getElementById("progress-bar")
    );
    this.progressBar.value = 0;
  }

  protected updateProgress(fileNumber, percent): void {
    this.progressBar.value = percent;
  }

  protected deleteImage(image) {
    let idBrand = this.getVnAppZone().app.params.idBrand;
    let formReq_url: string = this.getUrlBase() + "/images/delete/" + image.id;
    let formReq_params: Array<Array<string>> = [];

    let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(
      formReq_url,
      formReq_params,
      this
    );
    XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    XHRHdl.onReadyStateFunction = function (req, obj) {
      return function () {
        obj.manageResponse(req, obj, function () {
          let responseParsed = JSON.parse(req.request.response);

          obj.getImageData();
        });
      };
    };
    XHRHdl.execute();
  }

  protected setUpCkEditorTagsEditTextArea(isEnabled: boolean) {
    if (!isEnabled) {
      delete this.textAreaEditor;
      return;
    }

    if (this.textAreaEditor) {
      return;
    }

    const textArea = document.getElementById("tagsEditTextArea");
    if (!textArea) {
      return;
    }

    this.makeEditor(textArea).then((newEditor) => {
      this.textAreaEditor = newEditor;
    });
  }

  protected makeEditor(textArea: HTMLElement): Promise<any> {
    return classicEditor
      .create(textArea, this.CKEDITOR_CONFIG)
      .catch((error) => {
        console.error(error);
      });
  }

  public setTextAreaEditor(value) {
    if (!this.textAreaEditor) {
      this.setUpCkEditorTagsEditTextArea(true);
    }

    //ckeditor value can not be set to null, use ""
    if (!value) value = "";

    this.textAreaEditor.setData(value);
  }

  public getTextAreaEditor() {
    return !this.textAreaEditor ? "" : this.textAreaEditor.getData();
  }

  protected setUpCkEditorTagsEditDefaultTextArea(isEnabled: boolean) {
    if (!isEnabled) {
      delete this.textAreaEditor;
      return;
    }

    if (this.textAreaDefaultEditor) {
      return;
    }

    const textArea = document.getElementById("tagsEditDefaultTextArea");
    if (!textArea) {
      return;
    }

    this.makeEditor(textArea).then((newEditor) => {
      this.textAreaDefaultEditor = newEditor;
    });
  }

  public setTextAreaDefaultEditor(value) {
    if (!this.textAreaDefaultEditor) {
      this.setUpCkEditorTagsEditDefaultTextArea(true);
    }

    //ckeditor value can not be set to null, use ""
    if (!value) value = "";

    this.textAreaDefaultEditor.setData(value);
  }

  public getTextAreaDefaultEditor() {
    return !this.textAreaDefaultEditor
      ? ""
      : this.textAreaDefaultEditor.getData();
  }

  protected onAutocompleteInputClick(idElement) {
    switch (idElement) {
      case "filterAutocompleteProduct_template": {
        let filterTypes = this.editForm.filterAffiliates.getTemplateViewModel();

        if (filterTypes.addNewSelected()) {
          this.editForm.filterAffiliates.setOptions([]);
        }
        break;
      }
      case "filterAutocompleteProductType_template": {
        //this.editForm.onChangeSelectTag(); //May be unnecessary
        break;
      }
    }
  }

  protected getSuggestions(keyword, idSourceElement) {
    if (idSourceElement == "restrictionFilter") {
      let filterTypes = this.editForm.restrictionFilter.getTemplateViewModel();
      this.getTagTypesSuggestion(filterTypes.inputText(), 5);
    } else if (idSourceElement == "vignetteFilter") {
      const input = this.editForm.vignetteFilter
        .getTemplateViewModel()
        .inputText();
      this.getVignettesSuggestion(input, this.onGetVignettesSuggestionReturn);
    } else if (idSourceElement == "defaultVignetteFilter") {
      const input = this.editForm.defaultVignetteFilter
        .getTemplateViewModel()
        .inputText();
      this.getVignettesSuggestion(
        input,
        this.onGetDefaultVignettesSuggestionReturn
      );
    } else if (idSourceElement == "filterAutocompleteLocales_template") {
      const input = this.editForm.filterLocales
        .getTemplateViewModel()
        .inputText();
        this.getLocaleSuggestion(input);
    } else {
      this.XHRHdlCaller = "getSuggestions_" + idSourceElement;

      let filterAffiliates =
        this.editForm.filterAffiliates.getTemplateViewModel();
      this.getAffiliatesSuggestion(filterAffiliates.inputText(), 5);
    }
  }

  protected getAffiliatesSuggestion(keyword, limit) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { filter: { keyword: keyword, limit: limit } };
    let usrReq_url: string =
      "/api/brand/" +
      this.getVnAppZone().app.params.idBrand +
      "/search/affiliate/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetAffiliatesSuggestionReturn;
    this.XHRHdl.execute();
  }

  protected onGetAffiliatesSuggestionReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (
          obj.XHRHdlCaller ==
          "onAutocompleteAddNewInputChange_filterAutocompleteAffiliate_template"
        ) {
          obj.editForm.filterAffiliates
            .getTemplateViewModel()
            .suggestedObj(responseParsed.affiliates[0]);
        } else if (
          obj.XHRHdlCaller ==
          "getSuggestions_filterAutocompleteAffiliate_template"
        ) {
          obj.editForm.filterAffiliates.setOptions(responseParsed.affiliates);
        }
      });
    };
  }

  protected onPromptInputChangeClear(idElement) {
    this.clearValidationErrors();

    if (idElement === "filterAutocompleteAffiliate_template") {
      this.editForm
        .getTemplateViewModel()
        .affiliateAutomaticPricingAvailable(false);
      this.editForm.getTemplateViewModel().affiliateAutomaticPricing(null);
    }
  }

  protected onAutocompleteOptionChange(idElement) {
    if (idElement == "restrictionFilter") {
      let restrictionType = this.editForm.restrictionFilter
        .getTemplateViewModel()
        .optionObj();
      if (restrictionType) {
        let restrictionTypeArray = this.editForm
          .getTemplateViewModel()
          .restrictionTypeArray();
        let currentRestrictions = this.editForm
          .getTemplateViewModel()
          .restrictionTypeArray()
          .concat(
            this.editForm.getTemplateViewModel().oldRestrictionTypeArray()
          );
        let addRestriction = true;
        for (let i = 0; i < currentRestrictions.length; i++) {
          if (currentRestrictions[i].id == restrictionType.id) {
            addRestriction = false;
            break;
          }
        }
        if (addRestriction) {
          restrictionTypeArray.push(restrictionType);
          this.editForm
            .getTemplateViewModel()
            .restrictionTypeArray(restrictionTypeArray);
        }
        this.editForm.restrictionFilter.clearSelectedOption();
      }
    } else if (idElement == "filterAutocompleteAffiliate_template") {
      this.clearValidationErrors();

      if (this.editForm.filterAffiliates.getTemplateViewModel().optionObj()) {
        this.editForm.filterAffiliates
          .getTemplateViewModel()
          .placeholder("Affiliate Partner");
      }

      let partner = this.editForm.filterAffiliates.getOptionObj();
      let isAutoPricingChecked = this.editForm
        .getTemplateViewModel()
        .affiliateAutomaticPricing();
      let isAutoPricingCheckedAvailable = this.editForm
        .getTemplateViewModel()
        .affiliateAutomaticPricingAvailable();

      let showAutoPricing =
        partner.hasPricingSources === true ||
        isAutoPricingCheckedAvailable ||
        isAutoPricingChecked;
      let checkAutoPricing =
        partner.hasPricingSources === true || isAutoPricingChecked;

      this.editForm
        .getTemplateViewModel()
        .affiliateAutomaticPricingAvailable(showAutoPricing);
      this.editForm
        .getTemplateViewModel()
        .affiliateAutomaticPricing(checkAutoPricing);
    } else if (idElement == "vignetteFilter") {
      this.clearValidationErrors();
      this.editForm.setSelectedVignette(
        this.editForm.vignetteFilter.getOptionObj()
      );
    } else if (idElement == "defaultVignetteFilter") {
      this.clearValidationErrors();
      this.editForm.setSelectedDefaultVignette(
        this.editForm.defaultVignetteFilter.getOptionObj()
      );
    } else {
      this.clearValidationErrors();
      if (this.editForm.filterAffiliates.getTemplateViewModel().optionObj()) {
        this.editForm.filterAffiliates
          .getTemplateViewModel()
          .placeholder("Affiliate Partner");
      }
    }
  }

  public clearValidationErrors() {
    this.validationTemplate.clearMessages();
    this.editForm.removeValidationClass();
  }

  protected onAutocompleteInputClear(idElement) {
    if (idElement == "vignetteFilter") {
      this.editForm.setSelectedVignette(null);
    } else if (idElement == "defaultVignetteFilter") {
      this.editForm.setSelectedDefaultVignette(null);
    }
  }

  protected initializeCkEditors() {
    for (let name in CKEDITOR.instances) {
      CKEDITOR.instances[name].destroy(true);
    }

    if (!CKEDITOR.stylesSet.registered.my_styles) {
      CKEDITOR.stylesSet.add("my_styles", [
        // Block-level styles.
        { name: "Heading 1", element: "h1" },
        { name: "Heading 2", element: "h2" },
        { name: "Heading 3", element: "h3" },
        { name: "Preformatted", element: "pre" },
        // Inline styles.
        {
          name: "Related: One link",
          element: "span",
          attributes: { class: "related-single" },
        },
        {
          name: "Next - One link",
          element: "span",
          attributes: { class: "next-single" },
        },
        {
          name: "Affiliate - One link",
          element: "span",
          attributes: { class: "affiliate-single" },
        },
        {
          name: "Spoiler Alert",
          element: "span",
          attributes: { class: "article-alert" },
        },
        {
          name: "Tip",
          element: "div",
          attributes: { class: "emaki-custom tip" },
        },
        {
          name: "Warning",
          element: "div",
          attributes: { class: "emaki-custom warning" },
        },
        {
          name: "Note",
          element: "div",
          attributes: { class: "emaki-custom note" },
        },
        {
          name: "Expandable",
          element: "div",
          attributes: { class: "emaki-custom expandable" },
        },
        {
          name: "Pullquote",
          element: "div",
          attributes: { class: "emaki-custom pullquote" },
        },
      ]);
    }

    CKEDITOR.on("dialogDefinition", function (ev) {
      var dialogName = ev.data.name;
      var dialogDefinition = ev.data.definition;

      //remove features from table dialog
      if (dialogName == "table") {
        // Get the advanced tab reference
        var infoTab2 = dialogDefinition.getContents("advanced");

        //Set the default
        // Remove the 'Advanced' tab completely
        dialogDefinition.removeContents("advanced");

        // Get the properties tab reference
        var infoTab = dialogDefinition.getContents("info");

        // Remove unnecessary bits from this tab
        /// infoTab.remove('txtBorder');
        infoTab.remove("cmbAlign");
        infoTab.remove("txtWidth");
        infoTab.remove("txtHeight");
        // infoTab.remove('txtCellSpace');
        //infoTab.remove('txtCellPad');
        infoTab.remove("txtCaption");
        infoTab.remove("txtSummary");
      }

      if (dialogName == "link") {
        /* Getting the contents of the Target tab */

        var targetTab = dialogDefinition.getContents("target");
        var informationTab = dialogDefinition.getContents("info");
        var advancedTab = dialogDefinition.getContents("advanced");

        //remove the browse server button
        informationTab.remove("browse");

        //moving the target dropdown to the main tab
        var targetField = targetTab.get("linkTargetType");

        targetTab.remove("linkTargetType");
        informationTab.add(targetField);
      }
    });

    this.refreshDescriptionCkEditor();
  }

  public refreshDescriptionCkEditor(): void {
    // brand owners and non-default descriptions trigger this on load.
    if (
      this.editForm.getTemplateViewModel().automaticDefault() ||
      !this.editForm.getTemplateViewModel().useTagDefaults().description
    ) {
      this.initCkEditor("product_review_text");
      prodRevReviewText = CKEDITOR.instances.product_review_text;
    } else {
      prodRevReviewText = null;
    }
  }

  protected initCkEditor(idElement) {
    let height, toolbarMA;
    let disallowedContent = "p";
    //contextmenu,tabletools,tableselection
    let removePlugins = "elementspath,liststyle,image,forms";
    if (idElement == "product_review_text") {
      disallowedContent += ",ul,ol,li";
      removePlugins += ",list";
      toolbarMA = [
        [
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "SpecialChar",
          "ImgBtn",
          "Bold",
          "Italic",
          "Strike",
          "-",
          "LinkBtn",
          "Maximize",
        ],
      ];
      height = "250px";
    } else {
      height = "500px";
      toolbarMA = [
        [
          "Source",
          "-",
          "Cut",
          "Copy",
          "Paste",
          "-",
          "Undo",
          "Redo",
          "RemoveFormat",
          "-",
          "Link",
          "Unlink",
          "-",
          "Table",
          "HorizontalRule",
          "SpecialChar",
          "ImgBtn",
          "EmbedBtn",
          "UpdateBtn",
          "Styles",
        ],
        [
          "Bold",
          "Italic",
          "Strike",
          "NumberedList",
          "BulletedList",
          "-",
          "Blockquote",
          "LinkBtn",
          "Maximize",
        ],
      ];
    }

    CKEDITOR.replace(idElement, {
      height: height,
      toolbar: "MA",
      fillEmptyBlocks: false,
      extraAllowedContent:
        "img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*]",
      disallowedContent: disallowedContent,
      removePlugins: removePlugins,
      stylesSet: "my_styles",
      format_tags: "p;h1;h2;h3",
      format_p: {
        element: "p",
      },
      toolbar_MA: toolbarMA,
    });

    //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
    //'Outdent','Indent'

    //CKEDITOR.config.toolbar_MA = toolbarMA;

    CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

    CKEDITOR.config.contentsCss = [
      CKEDITOR.getUrl("contents.css"),
      "/css/cke_style.css?v=4.9",
    ];

    //CKEDITOR.config.disallowedContent = 'p';

    CKEDITOR.config.skin = "emakiCustomComprehensive";
    //CKEDITOR.config.skin ="kama";
    //CKEDITOR.config.skin ="moono";
    //CKEDITOR.config.skin ="moono-lisa";
    CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
    //CKEDITOR.config.extraPlugins ="justify";
    //CKEDITOR.config.extraPlugins ="colorbutton";

    CKEDITOR.config.forcePasteAsPlainText = false;
    contentEditor = CKEDITOR.instances.article_content;

    CKEDITOR.config.wordcount = {
      // Whether or not you want to show the Paragraphs Count
      showParagraphs: false,

      // Whether or not you want to show the Word Count
      showWordCount: true,

      // Whether or not you want to show the Char Count
      showCharCount: true,
    };
  }

  public setReviewText(text) {
    prodRevReviewText.setData(text, function () {
      this.resetUndo();
    });
  }

  public getReviewText() {
    if (prodRevReviewText) {
      return prodRevReviewText.getData();
    } else {
      return null;
    }
  }

  protected onAutocompleteAddNewSelected(idElement) {}

  protected onAutocompleteAddNewInputClick(idElement) {}

  protected onAutocompleteAddNewInputChange(idElement) {
    this.XHRHdlCaller = "onAutocompleteAddNewInputChange_" + idElement;
    this.getAffiliatesSuggestion(
      this.editForm.filterAffiliates.getTemplateViewModel().newOptionName(),
      1
    );
  }

  public isBrand(): boolean {
    let number = Number(this.getBrandId());
    return Number.isInteger(number);
  }

  public getBrandId(): number {
    return Number(this.getVnAppZone().app.params.idBrand);
  }

  public setIsImageOptimized(val) {
    // TODO implement method when you delete an image through imagePickerHelper
  }

  public insertVideo(param, target, data) {
    if (param === "insert" || param === "insert-save") {
      if (target === "tagVideo") {
        this.editForm.setTagVideo(data);
        this.getVideoPickerHelper().hideVideoPicker();
      }
    }
  }

  public filterMultipleSelectorOnChange(idElement) {
    switch (idElement) {
      case "categoryVideoFilter":
      case "contentTypeVideoFilter":
        this.getVideoPickerHelper().resetPagination();
        this.getVideoPickerHelper().getVideosData();
        break;
      case "filterVideoCategoryEdit":
        this.getVideoPickerHelper()
          .getVideoPickerEditTemplate()
          .updateSelectedCategories();
        break;
    }
  }

  public filterDropdownOnChange(idElement) {
    if (
      idElement == "videoOrientationFilter" ||
      idElement == "videoRatioFilter"
    ) {
      this.getVideoPickerHelper().resetPagination();
      this.getVideoPickerHelper().getVideosData();
    }else{
      this.getImageData();
    }
  }

  protected getUploadUrlSubtitles(): string {
    return this.getVideoPickerHelper().getUploadUrlSubtitles();
  }

  public viewImage(target) {
    this.editForm.viewImage(target);
  }

  public closeImage(target) {
    this.editForm.closeImage(target);
  }

  public removeImage(target) {
    this.editForm.removeImage(target);
  }

  protected showImagePicker(image, mode = "", selectedImages) {
    this.editForm.showImagePicker(image, mode, selectedImages);
  }

  public saveVideo(videoData, param?) {
    this.getVideoPickerHelper().handleSaveVideo(videoData, param);
  }

  public handleVideoUpload(files) {
    this.getVideoPickerHelper().handleVideoUpload(files);
  }

  protected getUsersSuggestion(keyword, idElement) {
    if (this.XHRHdl) {
      this.XHRHdl.cancelAndReset();
    }

    let subViewModel = { list: { keyword: keyword }, idElement: idElement };
    let usrReq_url: string = `/api/brand/${
      this.getVnAppZone().app.params.idBrand
    }/search/user/`;
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
    this.XHRHdl.execute();
  }

  protected onGetUsersSuggestionsReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        if (responseParsed.data.idElement == "filterUser_producer") {
          obj
            .getVideoPickerHelper()
            .getVideoPickerEditTemplate()
            .setProducer(responseParsed.data.users);
        }
      });
    };
  }
  public activateTagById() {

    if (this.XHRHdl) {
        this.XHRHdl.cancelAndReset();
    }

    let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/tags/activate/" + this.getVnAppZone().getApp().params.idTag;
    let usrReq_params: Array<Array<string>> = [];


    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onActivateTagReturn;
    this.XHRHdl.execute();

  }

  protected onActivateTagReturn(req, obj) {
    return function () {
        if (req.request.status == 400 && req.request.readyState == 4) {
          obj.cancel();
        }
        obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            if(responseParsed.success){
              window.location.reload();
            }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./js/modules/tags_edit.ts